export const MULTI_RECORD_PIN_PREFIX = 'MR'
export const PESTPAC_MULTI_RECORD_PIN_PREFIX = 'PPMR'

export function multiRecordPinId(latitude: number, longitude: number): string {
  return `${MULTI_RECORD_PIN_PREFIX}_${latitude.toFixed(6)}_${longitude.toFixed(6)}`
}

export function pestPacMultiRecordPinId(
  latitude: number,
  longitude: number,
): string {
  return `${PESTPAC_MULTI_RECORD_PIN_PREFIX}_${latitude.toFixed(6)}_${longitude.toFixed(6)}`
}

export function pestPacPinId(
  pestPacLocationId: string,
  locationCode?: string | null,
): string {
  return `${pestPacLocationId}_${locationCode ?? ''}`
}
